import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/FaqAccordion/FaqAccordion.js
const FaqAccordion = createSectionForm({
  icon: "question-answer-line",
  title: "FAQ Accordion",
  fields: [
    { name: "title", label: "Section Title" },
    {
      name: "faqs",
      label: "Questions",
      type: "list",
      itemLabel: "Question",
      fields: [
        { name: "question", label: "Question" },
        { name: "answer", label: "Answer", type: "textarea" },
      ],
    },
  ],
});

export default FaqAccordion;
